"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fluidLayoutDescriptor = exports.FluidLayoutDescriptor = void 0;
var constants_1 = require("./constants");
/**
 * @alpha
 */
var FluidLayoutDescriptor = /** @class */ (function () {
    function FluidLayoutDescriptor() {
        this.gridColumnsCount = constants_1.DASHBOARD_LAYOUT_GRID_COLUMNS_COUNT;
        this.gridRowHeight = constants_1.GRID_ROW_HEIGHT_IN_PX;
    }
    FluidLayoutDescriptor.prototype.toGridHeight = function (heightPx) {
        return Math.round(heightPx / this.gridRowHeight);
    };
    FluidLayoutDescriptor.prototype.toHeightInPx = function (height) {
        return height * this.gridRowHeight;
    };
    return FluidLayoutDescriptor;
}());
exports.FluidLayoutDescriptor = FluidLayoutDescriptor;
/**
 * @alpha
 */
exports.fluidLayoutDescriptor = new FluidLayoutDescriptor();
//# sourceMappingURL=FluidLayoutDescriptor.js.map